import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import './FAQ.css';
import { API_BASE } from './apiConfig';

const FAQ = () => {
  const { t, i18n } = useTranslation();
  const [faqs, setFaqs] = useState([]);
  const [showList, setShowList] = useState(false); 
  const [activeIndex, setActiveIndex] = useState(null);

  // Դինամիկ սկզբնական տվյալներ թարգմանության հիման վրա
  const initialFaqs = [
    { id: 1, question: t('faq_q1'), answer: t('faq_a1') },
    { id: 2, question: t('faq_q2'), answer: t('faq_a2') },
    { id: 3, question: t('faq_q3'), answer: t('faq_a3') }
  ];

  useEffect(() => {
    fetch(`${API_BASE}/api/faq`, {
      headers: {
        'ngrok-skip-browser-warning': 'true',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Accept-Language': i18n.language // Հայտնում ենք սերվերին, թե որ լեզվով ենք ուզում տվյալները
      }
    })
      .then(res => {
        if (!res.ok) throw new Error("Network response was not ok");
        return res.json();
      })
      .then(data => {
        if (Array.isArray(data) && data.length > 0) {
          setFaqs(data);
        } else {
          setFaqs(initialFaqs);
        }
      })
      .catch((err) => {
        console.error("FAQ Fetch Error:", err);
        setFaqs(initialFaqs);
      });
  }, [i18n.language, t]); // Թարմացնել, երբ լեզուն փոխվում է

  return (
    <div className="faq-outer-wrapper">
      <div className="faq-container">
        
        <div 
          className={`faq-main-toggle ${showList ? 'active' : ''}`} 
          onClick={() => setShowList(!showList)}
        >
          <div className="faq-title-side">
            <FontAwesomeIcon icon={faQuestionCircle} className="faq-main-icon" />
            <h2>{t('faq_main_title')}</h2>
          </div>
          <FontAwesomeIcon icon={showList ? faChevronUp : faChevronDown} className="faq-arrow" />
        </div>

        <div className={`faq-expandable-content ${showList ? 'is-open' : ''}`}>
          {faqs.map((f, index) => (
            <div key={f.id} className={`faq-card ${activeIndex === index ? 'active-card' : ''}`}>
              <div 
                className="faq-q" 
                onClick={() => setActiveIndex(activeIndex === index ? null : index)}
              >
                <span className="faq-q-text">{f.question}</span>
                <span className={`faq-icon-small ${activeIndex === index ? 'rotate' : ''}`}>
                   {activeIndex === index ? '−' : '+'}
                </span>
              </div>
              
              <div className={`faq-a ${activeIndex === index ? 'open' : ''}`}>
                <div className="faq-a-inner">
                  <p>{f.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQ;